export default __webpack_public_path__ + "static/media/menu.46035096.svg";